import AvatarInput from './AvatarInput';

export default AvatarInput;
